var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCommentsButtonDisabled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1363_6881)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.334 0.666242L19.9474 0.928909C20.0002 0.80635 20.015 0.670772 19.9898 0.539715C19.9647 0.408658 19.9009 0.288155 19.8065 0.193798C19.7121 0.09944 19.5916 0.0355702 19.4606 0.0104523C19.3295 -0.0146656 19.1939 0.00012444 19.0714 0.0529087L19.334 0.666242ZM0.667381 8.66624L0.404714 8.05291C0.291651 8.10122 0.194151 8.17986 0.122993 8.28013C0.0518356 8.3804 0.00979284 8.49839 0.00151344 8.62106C-0.00676596 8.74374 0.0190405 8.86631 0.0760796 8.97523C0.133119 9.08415 0.219168 9.17518 0.324714 9.23824L0.667381 8.66624ZM11.334 19.3329L10.762 19.6756C10.8251 19.7811 10.9161 19.8672 11.0251 19.9242C11.134 19.9812 11.2566 20.0071 11.3792 19.9988C11.5019 19.9905 11.6199 19.9485 11.7202 19.8773C11.8204 19.8061 11.8991 19.7086 11.9474 19.5956L11.334 19.3329ZM19.0714 0.0529087L0.404714 8.05291L0.930048 9.27958L19.5967 1.27958L19.0714 0.0529087ZM0.324714 9.23824L6.99138 13.2396L7.67671 12.0956L1.01005 8.09558L0.324714 9.23824ZM6.76072 13.0089L10.7607 19.6756L11.9047 18.9902L7.90471 12.3236L6.76072 13.0089ZM11.946 19.5956L19.946 0.928909L18.7194 0.403575L10.7194 19.0702L11.946 19.5956ZM18.862 0.195575L6.86205 12.1956L7.80605 13.1382L19.806 1.13824L18.862 0.195575Z",
    fill: "#babbc2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1363_6881"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommentsButtonDisabled);
export default __webpack_public_path__ + "static/media/comments-button-disabled.9d0280ed3c963aac5f932cd3424ed90a.svg";
export { ForwardRef as ReactComponent };